type ModEnterEvent = Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'preventDefault' | 'stopPropagation'>;

// Listen in the capture phase: Monaco claims Cmd+Enter for itself, so a bubbling handler never sees it.
export const onModEnter = (action: () => void) => (event: ModEnterEvent) => {
  if (event.key !== 'Enter' || !(event.metaKey || event.ctrlKey)) return;
  event.preventDefault();
  event.stopPropagation();
  action();
};
